import React, { useState } from 'react';
import reactDom from 'react-dom';
import { classIf } from '../../data/utils/classIf';

import { labels } from "../../data/labels";

function SportsDropdown(props) {
    const [showSportsDropdown, setShowSportsMenu] = useState(null);

    const container = document.querySelector('#sport-selector');
    if (container == null) {
        return null;
    }

    return reactDom.createPortal(
        <>
            <div className="d-flex align-items-center" onClick={() => setShowSportsMenu(!showSportsDropdown)}>
                <span className="text-small push-left text-bold">{props.selectedSport == null ? labels['prematch.sports_dropdown.all'] : props.selectedSport.descrizione}</span>
                <i className="fa fa-angle-down ml-1"></i>
            </div>
            {showSportsDropdown &&
                <div id="popup-calendar-sports" className="popup">
                    <div className="popup-content">
                        <div className={"event-desc text-small" + classIf(props.selectedSport == null, 'selected')} onClick={() => props.openAllSports()}>{labels['prematch.sports_dropdown.all']}</div>
                        {props.sports.map(sport => {
                            function handleClick() {
                                props.openSingleSport(sport);
                            }
                            return <div key={sport.id} className={"event-desc text-small" + classIf(props.selectedSport?.id === sport.id, 'selected')} onClick={handleClick}>{sport.descrizione}</div>
                        })}
                    </div>
                </div>
            }
        </>,
        container
    );
}

export default SportsDropdown;